import { ReturnReasonSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/return-reasons";
import { ReturnProductSchema } from "@redotech/redo-return-core-common/draft-return/draft-return-items";
import { ProductDataSchema } from "@redotech/redo-return-operations-common/customer-portal/product";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const ProductRecommendationSchema = z.object({
  recommendedProduct: ProductDataSchema,
  recommendedOptions: z.array(
    z.object({ name: z.string(), values: z.array(z.string()) }),
  ),
});

const MerchantGuidedRecommendationOutputSchema = z
  .object({
    /** @deprecated use recommendations.recommendedProduct instead */
    recommendedProduct: ProductDataSchema,
    /** @deprecated use recommendations.recommendedOptions instead */
    recommendedOptions: z
      .array(z.object({ name: z.string(), values: z.array(z.string()) }))
      .optional(),
    explanation: z.string().nullish().optional(),
    subtitle: z.string().nullish().optional(),
    outOfStockApology: z.string().nullish(),
    recommendations: z.array(ProductRecommendationSchema).optional(),
    recommendMultipleProducts: z.boolean(),
  })
  .nullable();

export type MerchantGuidedRecommendationOutput = z.infer<
  typeof MerchantGuidedRecommendationOutputSchema
>;

export const getMerchantGuidedRecommendations = unaryRpc({
  name: "getMerchantGuidedRecommendations" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnReasons: z.array(ReturnReasonSchema),
    locale: z.string().optional(),
  }),
  output: MerchantGuidedRecommendationOutputSchema,
});
